import '../globals';
import { Popover } from "bootstrap";

/**
 * Initialize Popovers
 */
(function(PageLoadedQueue) {
    const initPopovers = () => {
        const popovers = document.querySelectorAll('[data-toggle="popover"],[data-bs-toggle="popover"]');

        if (popovers.length) {
            Array.from(popovers).forEach((popoverEl) => {
                const popperConfig = {};

                if (popoverEl.dataset.bsPopperPlacement || popoverEl.dataset.plandentPlacement) {
                    popperConfig.placement = popoverEl.dataset.bsPopperPlacement ? popoverEl.dataset.bsPopperPlacement : popoverEl.dataset.plandentPlacement;
                }
                const popover = Popover.getOrCreateInstance(popoverEl, {
                    container: 'body',
                    popperConfig,
                    html: true
                });
            });
        }
    }

    window.PageLoadedQueue.addFunction(function() {
        initPopovers();
        document.addEventListener('plandent.html.changed', initPopovers, {passive: true});
    });
})(window.PageLoadedQueue);
